type SessionValue = string | number | boolean | object | null;

export const setSessionData = (key: string, value: SessionValue): void => {
  sessionStorage.setItem(key, JSON.stringify(value));
};

export const getSessionData = <T = unknown>(key: string): T | null => {
  const value = sessionStorage.getItem(key);

  if (!value) return null;

  try {
    return JSON.parse(value) as T;
  } catch {
    return null;
  }
};

export const removeSessionData = (key: string): void => {
  sessionStorage.removeItem(key);
};

export const isBookingAuthError = (error: unknown): boolean => {
  const status = (error as { response?: { status?: number } })?.response?.status;
  return status === 401 || status === 403;
};

// 409 from the v3 booking routes when the chosen slot was taken in the meantime.
export const isSlotUnavailableError = (error: unknown): boolean => {
  const response = (error as { response?: { status?: number; data?: { error?: string } } })
    ?.response;
  return response?.status === 409 && response?.data?.error === "SLOT_UNAVAILABLE";
};
